import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sitedata from "../sitedetails.json";
import SocialMedia from "./SocialMedia";
import { useDispatch, useSelector } from "react-redux";
import { Toaster, toast } from "react-hot-toast";
import {
  cancelSubscriptionAction,
  loadUserAction,
  logoutAction,
} from "../redux/actions/userAction";
import { updateProfilePictureAction } from "../redux/actions/profileAction";
const Profile = ({ user }) => {
  // const userData = props
  // console.log(userData)
  const dispatch = useDispatch();
  const { error, message } = useSelector((state) => state.user);
  const {
    loading: subLoading,
    error: subError,
    message: subMessage,
  } = useSelector((state) => state.subscription);
  const {
    loading: profileLoading,
    error: profileError,
    message: profileMessage,
  } = useSelector((state) => state.profile);

  const [image, setImage] = useState();
  // console.log(profileMessage)
  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({
        type: "clearError",
      });
    }

    if (profileError) {
      toast.error(profileError);
      dispatch({
        type: "clearError",
      });
    }

    if (profileLoading) {
      toast.success("Initiating Request");
      dispatch({
        type: "clearMessage",
      });
    }

    if (profileMessage?.success) {
      toast.success(profileMessage?.message);
      dispatch({
        type: "clearMessage",
      });
    }

    if (subLoading) {
      toast.success("Sending Request");
      dispatch({
        type: "clearMessage",
      });
    }

    if (message) {
      toast.success(message);
      dispatch({
        type: "clearMessage",
      });
    }

    if (subError) {
      toast.error(subError);
      dispatch({
        type: "clearError",
      });
    }

    if (subMessage) {
      toast.success(subMessage);
      dispatch({
        type: "clearMessage",
      });
    }
  }, [
    dispatch,
    error,
    message,
    subError,
    subMessage,
    subLoading,
    profileLoading?.message,
    profileMessage?.success,
    profileMessage?.message,
    profileError,
    profileLoading,
  ]);

  const logoutHandler = () => {
    dispatch(logoutAction());
  };

  const changeImageHandler = (e) => {
    // console.log(e.target.files[0])

    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      setImage(file);
      // console.log(reader.result)
      // console.log(file)
    };
  };

  const updateProfilePic = async (e) => {
    e.preventDefault();
    // console.log('pic update')

    const myForm = new FormData();
    myForm.append("file", image);
    // console.log(myForm)
    await dispatch(updateProfilePictureAction(myForm));
    // toast.success('Profile pic Updated!')
    dispatch(loadUserAction());
  };

  const cancelSubcriptionHandler = async () => {
    await dispatch(cancelSubscriptionAction());
    dispatch(loadUserAction());
  };

  return (
    <>
      <Toaster />
      <div className="w-full font-outfit">
        {/* max-w-[1512px] */}
        <div className=" h-[90px] items-center max-h-[96px] text-white flex pl-20 pr-10 bg-black lg:px-[230px] justify-between">
          {/* <img src={sitedata.brand_logo} alt="Logo" width="60px" /> */}
          <Link to="/">
            <h1 className=" text-brand_green text-lg font-semibold">
              {sitedata.brand_name}
            </h1>
          </Link>

          <div className="flex items-center">
            <Link to="/mycourses">
              <p className="px-8 hover:text-brand_green ">My Courses</p>
            </Link>
            <Link to="/blogs">
              <p className="px-8 hidden md:block hover:text-brand_green ">
                Blogs
              </p>
            </Link>
            {/* <h1 className="px-8 hover:text-brand_green ">Image</h1> */}
            <img
              className="w-[40px] h-[40px] rounded-full overflow-hidden "
              src={user.avatar.url}
              alt=""
            />
          </div>
        </div>
      </div>

      <div>
        <div className="bg-brand_nero flex flex-col lg:flex lg:flex-row font-outfit justify-center h-[600px] py-20 my-auto text-white gap-6  w-full">
          <div className="">
            <h1 className="bg-brand_green lg:mx-0 mx-6 py-3 px-8 text-center font-semibold rounded-md">
              My Profile
            </h1>
            <button
              onClick={() => {
                logoutHandler();
              }}
              className="hidden md:block lg:flex items-center px-2"
            >
              <h1 className="hover:underline py-3 px-8 text-center font-semibold">
                Log out
              </h1>
            </button>
          </div>
          <div className="bg-brand_jaguar h-[400px] px-12 py-6 flex flex-col lg:w-[600px]">
            <div className="flex-col flex items-center lg:items-start lg:flex lg:gap-4">
              <img
                className="w-[70px] h-[70px] rounded-full overflow-hidden"
                src={user?.avatar?.url}
                alt=""
              />

              <form className="flex"
                action=""
                onSubmit={(e) => {
                  updateProfilePic(e);
                }}
              >
                <input
                className="lg:w-auto w-52 lg:mx-0 mx-4"
                  onChange={(e) => {
                    changeImageHandler(e);
                  }}
                  type="file"
                  id="image_uploads"
                  accept=".jpg, .jpeg, .png"
                />
                <button className="px-1 py-1 rounded-md bg-green-500" type="submit">
                  update
                </button>
              </form>
            </div>

            <div className="flex flex-col gap-4 my-10">
              <div className="flex justify-start">
                {" "}
                <h1 className=" w-[100px] lg:w-[200px]">Name: </h1>
                <h1>{user && user?.name}</h1>{" "}
              </div>

              <div className="bg-white w-full h-[1px]"></div>
              <div className="flex justify-start">
                {" "}
                <h1 className="w-[100px] lg:w-[200px]">Email: </h1>
                <h1>{user && user?.email}</h1>{" "}
              </div>
              {/* <div className="bg-white w-full h-[1px]"></div> */}
              {/* <div className="flex justify-start">
                {" "}
                <h1 className="w-[200px]" >Contact Number: </h1>
                <h1>{user && user?.contact}</h1>{" "}
              </div> */}
              <div className="bg-white w-full h-[1px]"></div>
              <div className="flex justify-start">
                {" "}
                <h1 className=" w-[100px] lg:w-[200px]">Role: </h1>
                <div className="flex flex-row justify-between gap-16">
                  <h1>{user && user?.role}</h1>
                </div>
              </div>
              <div className="bg-white w-full h-[1px]"></div>

              <div className="flex justify-start">
                {" "}
                <h1 className="w-[100px] lg:w-[200px]">Subscription: </h1>
                <div className="flex flex-row justify-between gap-16">
                  <h1 className="text-brand_green font-semibold">
                    {user && user?.subscription?.status}
                  </h1>{" "}
                  {user?.subscription?.status === "active" ? (
                    <button
                      className="bg-red-600 rounded-md px-1 py-1"
                      onClick={() => {
                        cancelSubcriptionHandler();
                      }}
                    >
                      Cancel
                    </button>
                  ) : (
                    <Link to="/pricing">
                      <button className="px-1 py-1 text-black bg-brand_yellow">
                        Subscribe
                      </button>{" "}
                    </Link>
                  )}{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-brand_nero">
        <SocialMedia />
      </div>
      <div className="bg-[#1C1C1C] px-16 lg:px-[300px] h-full w-full font-outfit text-white">
        <div className="flex justify-between py-2">
          <h1>{sitedata.brand_name}</h1>
          <h1 className="hidden md:block">Privacy</h1>
          <h1 className="hidden md:block">Terms & Conditions</h1>
          <h1>Copyright © 2023</h1>
        </div>
      </div>
    </>
  );
};

export default Profile;
